export default __webpack_public_path__ + "static/media/360.c7c5205d.jpg";